"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASPNetRuntimeInstallationDirectoryProvider = void 0;
const path = require("path");
const IInstallationDirectoryProvider_1 = require("./IInstallationDirectoryProvider");
class ASPNetRuntimeInstallationDirectoryProvider extends IInstallationDirectoryProvider_1.IInstallationDirectoryProvider {
    getInstallDir(installId) {
        const dotnetInstallDir = path.join(this.getStoragePath(), installId);
        return dotnetInstallDir;
    }
}
exports.ASPNetRuntimeInstallationDirectoryProvider = ASPNetRuntimeInstallationDirectoryProvider;
//# sourceMappingURL=ASPNetRuntimeInstallationDirectoryProvider.js.map